import { Data, Keys } from "../textInterfaces";

import { TextComponentNameLevel2 } from "./../textConstants";
import { getComponentWrapper } from "./getComponentWrapper";

export function replaceComponentNameLevel2(
  component: Data,
  newLevel2: TextComponentNameLevel2,
): Data | undefined {
  return getComponentWrapper(replaceName(component, newLevel2));
}

export const replaceName = (
  component: Data,
  newLevel2: TextComponentNameLevel2,
): Keys => {
  const splitComponentName = component.name.split(".");
  return `${splitComponentName[0]}.${newLevel2}.${splitComponentName[2]}` as Keys;
};
